<mapfre-card
  [singleCard]="false"
  [additionalClasses]="'email-not-match ml-auto mr-auto'"
>
  <div class="policy-card">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon full-icon">
          <figure>
            <img src="./assets/img/images/icon-warning.svg" alt="no match" />
          </figure>
        </div>
        <h1 class="info-title-add-policy">
          {{ "This email is not associated with your policy" | translate }}
        </h1>
        <p class="mt-4 para ml-auto mr-auto">
          {{
            "The account email isn’t associated with your policy at this time, would you like to update your policy with this email?"
              | translate
          }}
        </p>
        <p class="mt-4 para txt-bold ml-auto mr-auto">
          {{ emailMask }}
        </p>
        <app-change-policy-email
          [policyId]="policyId"
          [userDetails]="userDetails"
          useAddnlClasses="primary basic"
        ></app-change-policy-email>
      </div>
    </div>
    <div class="single-card-column policy-card"></div>
  </div>
</mapfre-card>
